export const makeApiUrl = (path: string): string =>
  `${window.config.connection.backendUrl}${path}`;

export const makeDeamonUrl = (path: string): string =>
  `${window.config.connection.daemonUrl}${path}`;
